const $pageTitle = $('title');

let originalTitle,
    temporaryTitle = $('.page-wrapper').attr('data-page-title-unfocused');

if (typeof temporaryTitle !== 'undefined' && temporaryTitle.length > 0) {
    $(window).on('blur', function () {
        originalTitle = $pageTitle.text();
        $pageTitle.text(temporaryTitle + ' • ' + originalTitle);
    }).on('focus', function () {
        $pageTitle.text(originalTitle);
    });
}
